/**
 * 时间：2019年5月27日 14点53分
 * 说明：该文件用于存放文件操作工具
 */
import { getServerOSS } from "../core/options";

/**
 * 获取文件URL地址
 * @param {string} arg 参数
 * @param {number} index 索引位置
 */
export function getUrl(src = "", index = 0) {
  try {
    if (src.startsWith("http")) {
      return src;
    }
    const { baseURL } = getServerOSS();
    const urls = (src || "").split(",").map(s => s.trim()).filter(s => s);
    return index < urls.length ? baseURL + urls[index] : "";
  } catch (e) {
    console.log(e)
  }
  return ""
}
